import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useAxios from 'axios-hooks';

import { short } from '../../common/formatting/date';
import FullscreenToggle from '../components/FullscreenToggle';

const Observations = ({ patientId, onExpand, onContract, onDataExists }) => {
	const [{ data: observations, /* error */ }] = useAxios(`/patients/${patientId}/labs`);

	useEffect(() => {
		if (Array.isArray(observations) && observations.length > 0) {
			onDataExists();
		}
	}, [observations]);

	return (
		<div>
			<FullscreenToggle onExpand={onExpand} onContract={onContract} />
			{Array.isArray(observations) && observations.length > 0 && (
				<table className="table table-striped">
					<thead>
						<tr>
							<th>Observation</th>
							<th>Result</th>
							<th>Date Taken</th>
							<th>Source</th>
							<th>Updated On</th>
						</tr>
					</thead>
					<tbody>
						{observations.map((observation) => (
							<tr key={`${observation.id}`}>
								<td>{observation.name}</td>
								<td>{`${observation.result_value} ${observation.result_unit}`}</td>
								<td>{short(observation.lab_date, true)}</td>
								<td>{observation.data_source}</td>
								<td>{short(observation.update_dttm, true)}</td>
							</tr>
						))}
					</tbody>
				</table>
			)}
		</div>
	);
};

Observations.propTypes = {
	patientId: PropTypes.number,
	onExpand: PropTypes.func,
	onContract: PropTypes.func,
	onDataExists: PropTypes.func,
};

export default Observations;
